import supabase from "../supabase";

export const CHECK_STATE_LABELS = {
  0: "Pendiente",
  1: "Cobrado",
  2: "Rechazado",
};

export const getCheckStateLabel = (state) =>
  CHECK_STATE_LABELS[state] || "Desconocido";

export const logCheckStateChange = async ({
  paymentDetailsId,
  previousState = null,
  newState,
  source = null,
  checkNumber = null,
}) => {
  const changedBy = localStorage.getItem("username") || "desconocido";

  const historyData = {
    paymentDetailsId,
    checkNumber,
    previousState,
    newState,
    changedBy,
    source,
  };

  try {
    const { error } = await supabase
      .from("checkStateHistory")
      .insert([historyData]);

    if (error) {
      console.error("Error registrando historial de estado de cheque:", error);
    }
  } catch (error) {
    console.error("Error en logCheckStateChange:", error);
  }
};
